import CMultiSelect from "@/components/main/form/CMultiSelect";
import { Loader } from "@mantine/core";
import { useDebouncedState } from "@mantine/hooks";
import { IconBuildingBank } from "@tabler/icons-react";
import axios from "axios";
import { useEffect, useState } from "react";

const OrganizationsInput = ({ dictionary, form }) => {
  const [organizations, setOrganizations] = useState([]);
  const [search, setSearch] = useDebouncedState("", 300);
  const [loading, setLoading] = useState(false);

  const getOrganizations = async (search) => {
    try {
      setLoading(true);
      axios
        .get("/api/data/organizations/name", {
          params: { search },
        })
        .then((res) => {
          setOrganizations(res?.data?.data);
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getOrganizations("");
  }, []);

  useEffect(() => {
    if (search.length > 0) {
      getOrganizations(search);
    }
  }, [search]);

  return (
    <CMultiSelect
      data={
        form?.values?.organizations
          ? Array.from(
            new Set([...form?.values?.organizations, ...organizations])
          )
          : organizations
      }
      searchable
      placeholder={dictionary.organizations}
      className="mt-3"
      icon={<IconBuildingBank />}
      limit={5}
      hoverOnSearchChange={true}
      onSearchChange={(query) => {
        setSearch(query);
      }}
      filter={(value, selected, item) => {
        return (
          item.value.toLowerCase().startsWith(value.toLowerCase()) && !selected
        );
      }}
      rightSection={loading && <Loader variant="oval" size={26} />}
      {...form.getInputProps("organizations")}
    />
  );
};

export default OrganizationsInput;
